import { Component, OnInit, ViewChild, Input } from "@angular/core"; import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';

import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, LazyLoadEvent, ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { DialogService } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { EmployeEntite } from 'src/app/entites/employe';
import { EmployeService } from 'src/app/services/employe-service';

import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { ContextMenu } from 'primeng/contextmenu/public_api';
import { AppMainComponent } from 'src/app/app.main.component';
import { EStatuts } from "src/app/entites/enums/statuts";

@Component({
    templateUrl: './employes.component.html',
    styles: [`
        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class EmployesComponent extends BaseComponent implements OnInit {

    employes: EmployeEntite[];
    employesFiltres: EmployeEntite[];
    selectionEmploye: EmployeEntite;
    searchTerm = this.createParamSignal('searchTerm', '');
    menuContextuel: MenuItem[];

    @ViewChild('dt') table: Table;
    @ViewChild('menuContextuelItemCommande') menuContextuelItemCommande: ContextMenu;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, location: Location,
        private breadcrumbService: BreadcrumbService,
        private employeService: EmployeService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router) {
        super(sdb, profilService, route, routerService, appMain);
        this.breadcrumbService.setItems([
            { label: 'Employés' }
        ]);
    }

    ngOnInit() {
        // Allow both admin and regular employee access
        if (!this.estAutorise('employes_consulter') && !this.estAutorise('admin_employes')) {
            this.routerService.navigateByUrl('/access');
            return;
        }

        this.employeService.ObtenirListe().then(x => {
            this.employes = x.valeur;

            this.employes.forEach(x => {
                x.prenomNom = x.prenom + ' ' + x.nom;
            });

            this.employes.sort((a, b) => a.prenomNom.localeCompare(b.prenomNom));
            this.employes.sort((a, b) => {
                if (a.statut.statutId === EStatuts.Archive) return 1;
                if (b.statut.statutId === EStatuts.Archive) return -1;
                return a.statut.statutId - b.statut.statutId;
            });

            // Initialize filtered employees
            this.employesFiltres = [...this.employes];
            this.appliquerFiltres();

            this.CompleterChargement();
        });
    }

    menuContextuelEntrees: MenuItem[];
    surMenuContextuelItem(event, employe: EmployeEntite) {
        this.menuContextuelEntrees = [
            {
                label: 'Consulter',
                icon: 'pi pi-fw pi-eye',
                command: () => this.consulter(employe)
            },
            {
                label: 'Modifier',
                icon: 'pi pi-fw pi-pencil',
                command: () => this.modifier(employe),
                visible: this.estAutorise('employe_modifier') && (this.estAutorise('admin_employes') || employe.employeId === this.profilService.ProfilCourant().employeId)
            },
            { separator: true, visible: this.estAutorise('admin_employes') },
            {
                label: 'Imiter les rôles',
                icon: 'pi pi-fw pi-shield',
                command: () => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.impersoner(employe)
                },
                visible: this.estAutorise('admin_employes') && employe.employeId !== this.profilService.ProfilCourant().employeId && !this.profilService.EstEnModeImitation()
            },
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-trash',
                command: () => this.supprimer(employe),
                visible: this.estAutorise('admin_employes')
            },
        ];

        this.menuContextuelItemCommande.show(event);
    }

    consulter(employe: EmployeEntite) {
        this.routerService.navigate(['/employe', employe.employeId]);
    }

    modifier(employe: EmployeEntite) {
        this.routerService.navigate(['/employe', employe.employeId]);
    }

    ajouter() {
        this.routerService.navigate(['/employe', 0]);
    }

    supprimer(employe: EmployeEntite) {
        this.confirmationService.confirm({
            message: `Voulez-vous vraiment supprimer l'employé ${employe.prenom} ${employe.nom} ? (Veuillez vous assurer que l'employé sera archivé dans CTRL d'ici un mois ou il sera réactivé automatiquement.)`,
            header: 'Confirmation de suppression',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.employeService.Supprimer(employe.employeId).subscribe({
                    next: () => {
                        employe.statut = this.sdb.Statut(EStatuts.Archive);
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Employé supprimé avec succès' });
                    }
                });
            }
        });
    }

    impersoner(employe: EmployeEntite) {

        this.confirmationService.confirm({
            message: `Voulez-vous impersonner les rôles de ${employe.prenom} ${employe.nom} ? Vous aurez temporairement leurs rôles.`,
            header: 'Confirmation d\'impersonation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.profilService.ImpersonerEmploye(employe.employeId).subscribe({
                    next: () => {
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Mode imitation activé pour ${employe.prenom} ${employe.nom}` });
                        this.routerService.navigateByUrl('/');
                        window.location.reload();
                    }
                });
            },
            reject: () => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Impersonation annulée' });
            }
        });
    }

    filtrerInscrits() {
        this.appliquerFiltres();
    }

    appliquerFiltres() {
        this.employesFiltres = [...this.employes];

        // Apply search term filter if there's a search term
        const searchTerm = this.searchTerm()?.toLowerCase().trim();
        if (searchTerm) {
            this.employesFiltres = this.employesFiltres.filter(employe =>
                employe.nom?.toLowerCase().includes(searchTerm) ||
                employe.prenom?.toLowerCase().includes(searchTerm) ||
                employe.prenomNom?.toLowerCase().includes(searchTerm) ||
                employe.courriel?.toLowerCase().includes(searchTerm) ||
                employe.noEmploye?.toString().includes(searchTerm)
            );
        }
    }
}